import { useQuery } from "@tanstack/react-query";
import TicketsAdminService from "services/admin/ticketsService";
import { Ticket } from "interfaces/entities/ticket.model";

// Получить один тикет по ID. Используется на странице деталей /admin/tickets/:id.
// Включает messages (бэк отдаёт их в include при getByID), но мы их не используем —
// TicketMessages компонент сам тянет свой список через useGetTicketMessages.
export const useGetTicket = (ticketID: number | string | undefined) => {
    return useQuery<Ticket | null>({
        queryKey: ["tickets", ticketID],
        queryFn: async () => {
            if (!ticketID) return null;
            const response: any = await TicketsAdminService.get(ticketID);
            return response.data as Ticket;
        },
        enabled: !!ticketID,
    });
};
